// Session Expired Modal Manager
// This utility manages showing/hiding the session expired modal from non-React code

let modalCallback = null;

/**
 * Register the modal show callback
 * @param {Function} callback - Function to show the modal
 */
export const registerSessionExpiredModal = (callback) => {
  modalCallback = callback;
};

/**
 * Show the session expired modal
 */
export const showSessionExpiredModal = () => {
  if (modalCallback) {
    modalCallback();
  } else {
    // Fallback to alert if modal is not registered
    alert("Session Expired\n\nYour session has expired. Please login again.");
    handleLogoutRedirect();
  }
};

/**
 * Handle logout and redirect to login page
 */
export const handleLogoutRedirect = () => {
  // Clear all localStorage data
  localStorage.clear();
  
  // Redirect to login page
  window.location.href = "/";
};
